import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "row mx-1 mb-8",
  style: {"min-height":"350px"}
}
const _hoisted_2 = {
  key: 1,
  class: "col-lg-6 mt--5 col-md-6 d-md-flex flex-row-fluid ms-auto bgi-no-repeat bgi-size-cover",
  style: {"min-height":"200px","max-height":"500px","border-radius":"0.3rem"},
  autoplay: "",
  loop: "",
  muted: ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("source", {
  src: "media/bg-banner1.mp4",
  type: "video/mp4"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "col-sm-12 col-md-7 col-lg-7 px-lg-12 pt-5",
  style: {"border-top-right-radius":"0.3rem","border-bottom-right-radius":"0.3rem"}
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  id: "kt_carousel_1_carousel",
  class: "carousel carousel-custom slide",
  "data-bs-ride": "carousel",
  "data-bs-interval": "13000"
}
const _hoisted_8 = { class: "carousel-inner" }
const _hoisted_9 = {
  key: 0,
  class: "carousel-item active"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "carousel-item"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "carousel-item"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 3,
  class: "carousel-item"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between flex-wrap" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder pe-2" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "p-0 m-0 carousel-indicators carousel-indicators-dots"
}
const _hoisted_20 = {
  key: 0,
  "data-bs-target": "#kt_carousel_1_carousel",
  "data-bs-slide-to": "0",
  class: "ms-1 active"
}
const _hoisted_21 = {
  key: 1,
  "data-bs-target": "#kt_carousel_1_carousel",
  "data-bs-slide-to": "1",
  class: "ms-1"
}
const _hoisted_22 = {
  key: 2,
  "data-bs-target": "#kt_carousel_1_carousel",
  "data-bs-slide-to": "2",
  class: "ms-1"
}
const _hoisted_23 = {
  key: 3,
  "data-bs-target": "#kt_carousel_1_carousel",
  "data-bs-slide-to": "3",
  class: "ms-1"
}
const _hoisted_24 = {
  key: 0,
  class: "d-flex flex-center py-2 px-6 bg-white rounded"
}
const _hoisted_25 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-column-fluid" }, null, -1)
const _hoisted_29 = {
  key: 2,
  class: "col-sm-12 col-md-12 col-lg-7 d-flex justify-content-between mt-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-custom gutter-b", _ctx.cardMargin])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-body card-rounded p-0", _ctx.bgColor]),
      style: _normalizeStyle({ backgroundColor: _ctx.bgHex })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.bgImage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["col-lg-5 col-md-5 d-md-flex flex-row-fluid ms-auto bgi-no-repeat bgi-size-cover", _ctx.bgPosition]),
              style: _normalizeStyle([{ backgroundImage: 'url(' + _ctx.bgImage + ')' }, {"min-height":"200px","max-height":"100%","border-top-left-radius":"0.3rem","border-bottom-left-radius":"0.3rem"}])
            }, null, 6))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("video", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", {
            innerHTML: _ctx.titleText,
            class: _normalizeClass([_ctx.mb, "fw-bolder fs-1 text-dark py-5"]),
            style: {"font-size":"calc(3.5rem + 0.5vw) !important"}
          }, null, 10, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.subtitleText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "fs-1 py-5",
                style: {"word-wrap":"break-word"},
                innerHTML: _ctx.subtitleText
              }, null, 8, _hoisted_10),
              (_ctx.descriptionText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "fs-1",
                      style: {"word-wrap":"break-word"},
                      innerHTML: _ctx.descriptionText
                    }, null, 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.descriptionText1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "fs-1",
                      style: {"word-wrap":"break-word"},
                      innerHTML: _ctx.descriptionText1
                    }, null, 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.descriptionText2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: "fs-1",
                      style: {"word-wrap":"break-word"},
                      innerHTML: _ctx.descriptionText2
                    }, null, 8, _hoisted_16)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              (_ctx.descriptionText)
                ? (_openBlock(), _createElementBlock("ol", _hoisted_19, [
                    (_ctx.subtitleText)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_20))
                      : _createCommentVNode("", true),
                    (_ctx.descriptionText)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_21))
                      : _createCommentVNode("", true),
                    (_ctx.descriptionText1)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_22))
                      : _createCommentVNode("", true),
                    (_ctx.descriptionText2)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_23))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.searchCondition)
            ? (_openBlock(), _createElementBlock("form", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
                ]),
                _createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control border-0 fw-bold ps-2 w-xxl-350px", _ctx.width]),
                  placeholder: _ctx.searchText
                }, null, 10, _hoisted_26)
              ]))
            : _createCommentVNode("", true),
          (_ctx.bgImageSmall && false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-12 d-md-flex mt-5 flex-row-fluid my-auto bgi-no-repeat bgi-size-cover", _ctx.bgPosition]),
                  style: _normalizeStyle([{ backgroundImage: 'url(' + _ctx.bgImageSmall + ')' }, {"min-height":"10px","border-radius":"1rem"}])
                }, null, 6)
              ]))
            : _createCommentVNode("", true),
          _hoisted_28,
          (_ctx.displayToolbar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbsCollection.pages, (breadcrumb) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: breadcrumb.id,
                    to: breadcrumb.route,
                    class: "btn btn-icon btn-light pulse"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(breadcrumb.icon)
                      }, null, 2),
                      _withDirectives(_createElementVNode("span", {
                        class: _normalizeClass([breadcrumb.pulseColor, "pulse-ring"])
                      }, null, 2), [
                        [_vShow, breadcrumb.pulse]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 6)
  ], 2))
}